import React from 'react';

const UserContext = React.createContext({
  authUser: null,       // This will store the Firebase Auth user
  adminDetails: null   // This will store additional details from Firestore
});

export default UserContext;
